import _ from 'lodash'

export const valid = (value) => ({
  value,
  is: {},
  isOk: true,
  getErrorMessages: () => [],
  getAllMessages: () => [],
})

export const invalid = (value) => ({
  value,
  is: {},
  isOk: false,
  getErrorMessages: () => [],
  getAllMessages: () => [],
})

export const CheckedImpl = (dependencies, specs, value) => {
  const templatizeWhenItIsAFunction = (msg) => {
    return typeof msg === 'string' ? msg : msg(dependencies, value)
  }

  let allMessages = specs
    .filter(([, { rule }]) => rule(dependencies, value) === false)
    .map(([, { type, message }]) => ({
      type,
      message: templatizeWhenItIsAFunction(message),
    }))

  return {
    get value() {
      return value
    },
    get isOk() {
      return allMessages.filter((obj) => obj.type !== 'ADDITIONAL_INFORMATION').length === 0
    },
    get is() {
      return specs
        .map(([key, { rule }]) => ({ [key]: rule(dependencies, value) }))
        .reduce((acc, curr) => _.merge(acc, curr), {})
    },
    /**
     * @param message {{ type: string, message: string }}
     */
    addMessage(message) {
      allMessages.push(message)
    },
    getAllMessages() {
      return allMessages
    },
    getErrorMessages(selectedType) {
      if (selectedType) {
        return allMessages.filter((obj) => obj.type === selectedType).map((obj) => obj.message)
      }
      return allMessages.map((obj) => obj.message)
    },
  }
}

export const createChecker = (specs) => (dependencies, value) => CheckedImpl(dependencies, specs, value)
